// Shared error/touched helpers for onboarding widgets

export type TouchedMap = {[key: string]: {[key: string]: boolean | undefined}}

/**
 * Returns true if any field in the widget has been touched.
 */
export function anyWidgetFieldTouched(touched: TouchedMap): boolean {
  return Object.values(touched).some(t => Object.values(t).some(Boolean))
}

/**
 * Returns true if any of the required fields are empty.
 * @param requiredFields array of required field names
 * @param rows array of row objects (e.g. pipelines, repos, etc.)
 */
export function hasEmptyRequiredFields(requiredFields: string[], rows: any[]): boolean {
  return rows.some(row => requiredFields.some(field => !row[field]))
}
